import { CurrencyProps } from "../types";

export type PaymentMethod = "stripe" | "flutterwave" | "paystack";

const paymentCountry = (process.env.REACT_APP_PAYMENT_COUNTRY || "")
  .trim()
  .toLowerCase();

export const isBrazilPaymentCountry = paymentCountry === "brazil";

export const getAvailablePaymentMethods = (): PaymentMethod[] => ["stripe"];

export const getDefaultPaymentMethod = (): PaymentMethod =>
  getAvailablePaymentMethods()[0];

export const getPreferredPaymentCurrency = (
  detectedCurrency?: CurrencyProps
): CurrencyProps => {
  if (isBrazilPaymentCountry) {
    return "BRL";
  }

  return detectedCurrency ?? "GBP";
};
